import { useSelector } from "react-redux";

import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout"
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import { RECEIVER_REJECTED } from "../apiEndpoints";
import ReceiverRejectedExpenses from "../components/receiverRejected/ReceiverRejectedExpenses";

const ReceiverRejectedExpensesPage = () => {
  const { isLoaded } = useFetchData(RECEIVER_REJECTED);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);

  return (
    <MainPageLayout headerConfig={{ title: "Rejected Company Expenses" }}>
      {isLoaded && !error ? (
        <ReceiverRejectedExpenses />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default ReceiverRejectedExpensesPage;
